import React from 'react'
import { Accordion as MUIAccordion, AccordionSummary } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'
import { ArrowDown2 } from 'iconsax-react'
//https://iconsax-react.pages.dev/

export const StyledAccordion = withStyles(() => ({
  root: {
    border: 'none',
    boxSizing: 'border-box',
    boxShadow: 'none',

    '&:before': {
      display: 'none'
    },

    '& .MuiAccordionSummary-root.Mui-focused': {
      backgroundColor: 'transparent'
    }
  },

  expanded: {
    margin: '0px 0px !important'
  }
}))(MUIAccordion)

export const StyledSummary = withStyles(theme => ({
  root: {
    minHeight: '44px !important',
    paddingRight: '10px !important',
    justifyContent: 'flex-start',

    '& .summaryIcon': {
      color: '#1F1F1F',
      fontSize: theme.size.base,
      height: 16,
      width: 16
    }
  },

  content: {
    margin: '0px 0px !important',
    flexGrow: '0 !important'
  }
}))(({ expanded, ...props }) => {
  const Icon = React.useMemo(() => ArrowDown2, [])

  return (
    <AccordionSummary
      expandIcon={<Icon className='summaryIcon' />}
      {...props}
    />
  )
})

const useStyles = makeStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: `minmax(50px, auto) auto`,
    alignItems: 'center',
    fontSize: theme.size.sm,

    '& .headerIcon': {
      alignSelf: 'center',
      marginRight: '0.5rem',
      fontSize: theme.size.sm,
      color: 'rgba(0, 0, 0, 0.7)'
    },

    '& label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      cursor: 'pointer'
    }
  },

  content: {
    width: '100%',
    fontSize: theme.size.sm,
    color: '#1F1F1F'
  },

  show: {
    float: 'right',
    paddingRight: '0.25rem',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    userSelect: 'none',

    '&:hover': {
      color: theme.palette.primary.light
    }
  },

  dot: {
    width: '0.44rem',
    height: '0.44rem',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    borderRadius: '50%',
    marginRight: '0.5rem'
  },

  count: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100rem',
    height: '18px',
    padding: '0 5px',
    background: '#B64FCD',
    fontSize: theme.size.sm,
    color: 'white',
    cursor: 'default'
  },

  summaryContainer: {
    display: 'flex',
    alignItems: 'center'
  },

  selected: {
    display: 'grid !important',
    gridTemplateColumns: `auto minmax(50px, auto) auto`,
    color: theme.palette.primary.main,

    '& label': {
      color: theme.palette.primary.main,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      cursor: 'pointer',
      textOverflow: 'ellipsis'
    }
  }
}))

export default useStyles
